import { listJetCallReports } from 'api/admin/jet/listJetCallReports'
import { getJetCallReportStatusSummary } from 'api/admin/jet/getJetCallReportStatusSummary'
import { listJetAlerts } from 'api/admin/jet/listJetAlerts'
import { listJetAssignments } from 'api/admin/jet/listJetAssignments'

export const jetKey = ['jet']

export const jetKeys = {
  all: jetKey,
  callReports: () => [...jetKey, 'callReports'] as const,
  callReportsList: (params?: Parameters<typeof listJetCallReports>[0]) =>
    [
      ...jetKeys.callReports(),
      params?.page,
      params?.pageSize,
      params?.daysAgo,
      params?.statuses,
      params?.search,
    ] as const,
  statusSummary: (
    params?: Parameters<typeof getJetCallReportStatusSummary>[0]
  ) => [...jetKeys.callReports(), 'statusSummary', params?.daysAgo] as const,
  alerts: () => [...jetKey, 'alerts'] as const,
  // Keyset-paginated one page at a time: the cursor is part of the key so each
  // Prev/Next page is its own cached entry (changing filters/sort resets paging
  // because those key parts change too).
  alertsList: (params?: Parameters<typeof listJetAlerts>[0]) =>
    [
      ...jetKeys.alerts(),
      params?.limit,
      params?.alertTypes,
      params?.status,
      params?.dateField,
      params?.daysAgo,
      params?.sortBy,
      params?.sortDir,
      params?.cursor,
    ] as const,
  assignments: () => [...jetKey, 'assignments'] as const,
  // Keyset-paginated one page at a time: the cursor is part of the key so each
  // Prev/Next page is its own cached entry (changing filters/sort resets paging
  // because those key parts change too).
  assignmentsList: (params?: Parameters<typeof listJetAssignments>[0]) =>
    [
      ...jetKeys.assignments(),
      params?.limit,
      params?.statuses,
      params?.assignmentId,
      params?.shiftId,
      params?.dateField,
      params?.daysAgo,
      params?.sortBy,
      params?.sortDir,
      params?.cursor,
    ] as const,
}
